<template>
  <a-modal class="select-moodal-box"
    destroyOnClose
    :wrapClassName="wrapClassName"
    :title="title"
    :visible="visible"
    @cancel="() => { $emit('cancel') }"
    @ok="handleConfirm"
    :bodyStyle="{padding:'8px 12px 0 12px'}"
    :width="width"
    :okText="t('wg.bt.confirm')"
    :cancelText="t('wg.bt.cancel')">
    <div>
      <a-collapse accordion
        :bordered="false"
        defaultActiveKey="1"
        v-if="conditionFields.list.length>0">
        <a-collapse-panel key="1"
          :header="t('wg.bt.filter')">
          <wg-form :jsonData="conditionFields"
          @on-enter="handleEnter"
          @on-type^VEQ-change="handleType"
            ref="dyForm">
            <template #buttons>
              <div style="text-align:right;">
                <a-button type="primary"
                  icon="search"
                  @click="handleSearch">
                  {{t('wg.bt.query')}}
                </a-button>
                <a-button :style="{ marginLeft: '8px' }"
                  icon="reload"
                  @click="handleReset">
                  {{t('wg.bt.reset')}}
                </a-button>
              </div>
            </template>
          </wg-form>
        </a-collapse-panel>
      </a-collapse>
    </div>
    <a-table style="margin-top:8px;"
      :bordered="true"
      :scroll="{ x:maxWidth, y: 380 }"
      :dataSource="pageSource.rows"
      :pagination="pagination"
      :columns="newColumns"
      :loading="loading"
      size="small"
      :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange, type: multiple ? 'checkbox' : 'radio'}"
      @change="handlePageChange"
      :rowKey="rowKey">
    </a-table>
  </a-modal>
</template>

<script>
import { t } from '../../locale';

export default {
  name: 'selectModalBox',
  props: {
    wrapClassName: {
      type: String,
      default: '',
    },
    width: {
      type: [String, Number],
      default: 800,
    },
    rowSelection: Object,
    dialogKey: {
      type: String,
      default: '',
    },
    rowKey: {
      type: String,
      default: 'key',
    },
    // 表格数据列定义
    columns: {
      type: Array,
      default: () => [],
    },
    // 是否序号列
    sn: {
      type: Boolean,
      default: true,
    },
    // 是否多选
    multiple: {
      type: Boolean,
      default: true,
    },
    // 是否打开
    visible: {
      type: Boolean,
      default: false,
    },
    // 标题
    title: {
      type: String,
      default: '',
    },
    conditionFields: {
      type: Object,
      default: () => {},
    },
    pageSource: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedRowKeys: [],
      records: {},
      keyword: '',
      loading: false,
      total: 0,
      current: 1,
      pageSize: 10,
      query: {},
    };
  },
  watch: {
    visible(val) {
      if (!val) {
        this.current = 1;
        this.query = {};
      }
      // 如果单选
      if (!this.multiple) {
        this.selectedRowKeys = [];
        this.records = {};
      }
      // 先清空对象
      // this.selectedRowKeys = [];
      // this.records = {};
      // // 打开时，搜索数据
      // if (val) {
      //   this.fetchData({ current: this.current });
      // }
    },
  },
  computed: {
    // 表格分页配置
    pagination() {
      const { pageNum, total } = this.pageSource;
      return {
        current: pageNum,
        total,
        showSizeChanger: true,
        showQuickJumper: false,
        change: 'handlePageChange',
      };
    },
    maxWidth() {
      // 重新整理表格字段数组
      const colWidth = 180;
      let maxWidth = 150;
      const len = this.columns.length;
      this.columns.forEach((item, index) => {
        /* eslint-disable */
        if (!item.width) {
          if (index + 1 < len) {
            item.width = colWidth;
          }
        }
        /* eslint-enable */
        let width = parseInt(item.width, 10);
        if (Number.isNaN(width)) {
          width = colWidth;
        }
        maxWidth += width;
      });
      return maxWidth;
    },

    newColumns() {
      // 序号列
      if (this.sn) {
        return [
          {
            title: '#',
            align: 'center',
            width: 80,
            customRender: (text, record, index) => (this.current - 1) * this.pageSize + index + 1,
          },
          ...this.columns,
        ];
      }
      return [...this.columns];
    },
  },
  created() {},
  mounted() {},

  methods: {
    t(...args) {
      return t.apply(this, args);
    },
    handleEnter() {
      this.handleSearch();
    },
    handleReset() {
      this.$refs.dyForm.reset();
    },
    handleSearch() {
      this.query = this.$refs.dyForm.getData().queryModel;
      this.fetchData({ current: 1 });
    },
    //
    setBusinessObject({ dataSource, total }) {
      this.dataSource = dataSource;
      this.total = total;
    },
    showLoading() {
      this.loading = true;
    },
    closeLoading() {
      this.loading = false;
    },
    fetchData({ current, sort = { field: undefined, order: 'asc' } }) {
      const { pageSize, query } = this;
      this.current = current;
      const { field, order } = sort;
      this.$emit('fetch', {
        offset: (current - 1) * pageSize,
        limit: pageSize,
        field,
        order,
        ...query,
      });

      // this.$emit('fetch', {
      //   pageNum: current,
      //   pageSize,
      //   sort,
      //   ...query,
      // });

      // this.loading = true;
      // this.$bus.emit('getBusinessObject', {
      //   pageNum: current,
      //   pageSize,
      //   sort,
      //   query,
      // });
    },

    handlePageChange({ current, pageSize }, filters, sorter) {
      this.pageSize = pageSize;
      const { order, field } = sorter;
      if (order) {
        /* eslint-disable */
        sorter.order = order.replace('end', '');
        /* eslint-enable */
      }
      this.current = current;
      this.fetchData({
        current,
        sort: { field, order: sorter.order },
      });
    },

    handleConfirm() {
      const data = [];
      const { rowKey } = this;
      // 取出键值对中的数据
      Object.keys(this.records).forEach((key) => {
        const row = this.records[key];
        const rowId = row[rowKey];
        if (this.selectedRowKeys.includes(rowId)) {
          data.push(row);
        }
      });
      this.$emit('confirm', this.selectedRowKeys, data);
    },
    onSelectChange(selectedRowKeys, records) {
      this.selectedRowKeys = selectedRowKeys;
      const { rowKey } = this;
      records.forEach((item) => {
        this.records[item[rowKey]] = item;
      });
    },
    onSearch(value) {
      // 准备过滤条件
      this.query = {
        keyword: value,
      };
      // 查询
      this.fetchData({ current: 1 });
    },
    handleType(param) {
      if (this.dialogKey === 'listExpenses') {
        this.$emit('condition', { [param.field]: param.value });
      }
    },
  },
};
</script>
